import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { EmpleoService } from '../../service/empleo.service'
import { UbicacionesService } from '../../service/ubicaciones.service'
import { NgForm } from '@angular/forms';
import { DatePipe, formatDate } from '@angular/common';
import { SeoService } from '../../service/seo.service';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { timer } from 'rxjs';

@Component({
  selector: 'app-empleo',
  templateUrl: './empleo.component.html',
  styleUrls: ['./empleo.component.css']
})
export class EmpleoComponent implements OnInit {
    private subscription: Subscription = new Subscription();
    civiles: any;
    academicos: any;
    empresas: any;
    nacademicos: any;
    oestudios: any;
    perfiles: any;
    sexos: any;
    isReadonly = false;
    estados: any;
    ciudades: any;
    areas = [{
            "idArea": 0,
            "nombreArea": "Administrativo"
        },
        {
            "idArea": 1,
            "nombreArea": "Salud"
        }
    ];
    send = false;
    years = new Array();
    startYear = 1940;
    endYear = new Date().getFullYear();
    selectedItemsList = new Array();
    checkedIDs = [];
    
    FechaIncioAcademico: Date | undefined;
    myForm: any;
    srcfinal: string | undefined;
    postulantekey: any;
    
    // srcfinal: string;
    
    RouteText: any;
    tituloseo: any;
    urlcanonicaseo: any;
    imagenseo: any;
    keywordsseo: any;
    descripcionseo: any;

    confirma = false;
    succes= false;
    
    constructor(
        private meta: Meta,
        private title: Title,
        private router: Router,
        private datePipe: DatePipe,
        private _ubicacionesService: UbicacionesService,
        private _empleoService: EmpleoService,
        private _seoService: SeoService,
        private _urlcanonicaservice: UrlcanonicaService
    
    ) {
    
        this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.RouteText = event;
            this.getSEO(event.url)
        });
    
        for (this.startYear; this.startYear <= this.endYear; this.startYear++) {
            this.years.push({
                "year": this.startYear
            });
        }
    
    }
    
    ngOnInit(): void {
        this.goCivil();
        this.getnivelAcademico();
        this.getgiroempresa();
        this.goAcademico();
        this.getotrosestudios();
        this.getsexo();
        this.getEstados();
    }
    
    changeSelection(check: any) {
        this.selectedItemsList.push(check)
    }
    
    
    getEstados() {
        this.subscription.add(
            this._ubicacionesService.getEstados().subscribe((resp: any) => {
                this.estados = resp;
    
            })
        );
    }
    
    getCiudades(estadoId: number) {
        this.subscription.add(
            this._ubicacionesService.getCiudades(estadoId).subscribe((resp: any) => {
                this.ciudades = resp;
            })
        );
    }
    
    goCivil() {
        this.subscription.add(
            this._empleoService.getestadocivil().subscribe((resp: any) => {
                this.civiles = resp;
            })
        );
    }
    
    goAcademico() {
        this.subscription.add(
            this._empleoService.getestatusacademico().subscribe((resp: any) => {
                this.academicos = resp;
            })
        );
    }
    
    getgiroempresa() {
        this.subscription.add(
            this._empleoService.getgiroempresa().subscribe((resp: any) => {
                this.empresas = resp;
            })
        );
    }
    
    getnivelAcademico() {
        this.subscription.add(
            this._empleoService.getnivelacademico().subscribe((resp: any) => {
                this.nacademicos = resp;
            })
        );
    }
    
    getotrosestudios() {
        this.subscription.add(
            this._empleoService.getotrosestudios().subscribe((resp: any) => {
                this.oestudios = resp;
            })
        );
    }
    
    getperfil(event: any) {
    
        this.subscription.add(
            this._empleoService.getperfil(event).subscribe((resp: any) => {
                this.perfiles = resp;
            })
        );
    }
    
    getsexo() {
        this.subscription.add(
            this._empleoService.getsexo().subscribe((resp: any) => {
                this.sexos = resp;
            })
        );
    }
    
    stageFile(event: any): void {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                this._empleoService.UploadImage(file).subscribe((resp: any) => {
                    this.srcfinal = "https://fundacionbest.org.mx/WebApi" + resp.substr(2);
                    this.send = true;
                });
            } else {}
        }
    }
    
    onSubmit(form: NgForm) {
        if (form.value.AreaTrabajo == 0) {
            form.value.AreaTrabajo = 'Administrativo'
        } else if (form.value.AreaTrabajo == 1) {
            form.value.AreaTrabajo = 'Salud'
        }
        var Fetrnsfin = "10" + "-" + "03" + "-" + form.value.fechaFinAcedemico;
        form.value.fechaFinAcedemico = formatDate(Fetrnsfin, 'yyyy-MM-dd', 'en');
    
        var Fetrnsin = "10" + "-" + "03" + "-" + form.value.fechaInicioAcedemico;
        form.value.fechaInicioAcedemico = formatDate(Fetrnsin, 'yyyy-MM-dd', 'en');
    
        const Postulante = {
            areaTrabajo: form.value.AreaTrabajo,
            idPerfil: form.value.perfil,
            nombre: form.value.nombre,
            ApellidoPaterno: form.value.apellidoPaterno,
            ApellidoMaterno: form.value.apellidoMaterno,
            email: form.value.email,
            telefono: form.value.telefono,
            IdEstadoCivil: form.value.edocivil,
            edad: form.value.fechanacimiento,
            nacionalidad: form.value.Nacionalidad,
            IdSexo: form.value.sexo
        };
    
        var domicilio: {
            [k: string]: any
        } = {};
        domicilio = {
            Calle: form.value.Calle,
            NumeroInterior: form.value.numeroInterior,
            NumeroExterior: form.value.numeroExterior,
            Colonia: form.value.Colonia,
            Pais: form.value.Pais,
            codigoPostal: form.value.codigoPostal,
            idEstado: form.value.estadoId,
            idMunicipio: form.value.ciudadId
        };
    
        var academico: {
            [k: string]: any
        } = {};
        academico = {
            InstitucionEducativa: form.value.InstitucionEducativa,
            IdNivelAcademico: form.value.nivelacademico,
            AnoInicio: form.value.fechaInicioAcedemico,
            AnoTermino: form.value.fechaFinAcedemico,
            IdEstatus: form.value.estatusacademico,
            CedulaProfesional: form.value.cedulaProfesiona
        };
        this.confirma = true;
        this._empleoService.postPostulante(Postulante).subscribe(resp => {
                if(resp == false){
                    alert("Ya tienes una postulacion")
                }else{
                    this.postulantekey = resp;
                    domicilio.IdPostulante = this.postulantekey;
                    academico.IdPostulante = this.postulantekey;

                    this._empleoService.postDomicilio(domicilio).subscribe(
                        resp => {
                            if (resp == true) {
                                this._empleoService.postAcademico(academico).subscribe(
                                    resp => {
                                        if (resp == true) {
                                            if (form.value.empresa) {
                                                var Fetrnsfin = "10" + "-" + "03" + "-" + form.value.fechaFinUltimoTrabajo;
                                                form.value.fechaFinUltimoTrabajo = formatDate(Fetrnsfin, 'yyyy-MM-dd', 'en');
                                                var Fetrnsin = "10" + "-" + "03" + "-" + form.value.fechaInicioUltimoTrabajo;
                                                form.value.fechaInicioUltimoTrabajo = formatDate(Fetrnsin, 'yyyy-MM-dd', 'en');
                                                if (form.value.laboraactualmente === '1') {
                                                    form.value.laboraactualmente = true;
                                                } else {
                                                    form.value.laboraactualmente = false;
                                                }


                                                var experiencia: {
                                                    [k: string]: any
                                                } = {};
                                                experiencia = {
                                                    empresa: form.value.empresa,
                                                    IdGiroEmpresa: form.value.giroempresa,
                                                    Puesto: form.value.puesto,
                                                    FechaInicio: form.value.fechaInicioUltimoTrabajo,
                                                    FechaFin: form.value.fechaFinUltimoTrabajo,
                                                    LaboraActualMenteAqui: form.value.laboraactualmente
                                                };
                                                experiencia.IdPostulante = this.postulantekey;
                                                experiencia.CvUrl = this.srcfinal;
                                                this._empleoService.postExperiencia(experiencia).subscribe(
                                                    resp => {
                                                        this.confirma = false;
                                                        const successIn = timer (500);
                                                        const successOut = timer (3500);
                                                        successIn.subscribe((n) =>{
                                                            this.succes= true;
                                                            successOut.subscribe((n) =>{
                                                                this.succes= false;
                                                                this.router.navigate(['/']);
                                                            })
                                                        });
                                                    },
                                                    error => {
                                                        alert("error")
                                                    });
                                            }
                                            if (form.value.empresados) {
                                                var Fetrnsfin = "10" + "-" + "03" + "-" + form.value.fechaFinPenUltimoTrabajo;
                                                form.value.fechaFinPenUltimoTrabajo = formatDate(Fetrnsfin, 'yyyy-MM-dd', 'en');
                                                var Fetrnsin = "10" + "-" + "03" + "-" + form.value.fechaInicioPenUltimoTrabajo;
                                                form.value.fechaInicioPenUltimoTrabajo = formatDate(Fetrnsin, 'yyyy-MM-dd', 'en');
                                                var experienciados: {
                                                    [k: string]: any
                                                } = {};
                                                experienciados = {
                                                    empresa: form.value.empresados,
                                                    IdGiroEmpresa: form.value.giroempresados,
                                                    Puesto: form.value.puestodos,
                                                    FechaFin: form.value.fechaFinPenUltimoTrabajo,
                                                    FechaInicio: form.value.fechaInicioPenUltimoTrabajo,
                                                    LaboraActualMenteAqui: false
                                                };
                                                experienciados.IdPostulante = this.postulantekey;
                                                experienciados.CvUrl = this.srcfinal;
                                                this._empleoService.postExperiencia(experienciados).subscribe(
                                                    resp => {},
                                                    error => {
                                                        alert("error")
                                                    });
                                            }
                                            if (this.selectedItemsList) {
                                                var i
                                                var otros: {
                                                    [k: string]: any
                                                } = {};
                                                for (i = 0; i <= this.selectedItemsList.length - 1; i++) {
                                                    otros.IdPostulante = this.postulantekey;
                                                    otros.IdOtrosEstudios = this.selectedItemsList[i];

                                                    this._empleoService.postOtrosEstudios(otros).subscribe(
                                                        resp => {},
                                                        error => {
                                                            alert("error")
                                                        }
                                                    );
                                                }


                                            }
                                        }
                                    },
                                    error => {
                                        alert("error")
                                    }
                                );
                            }
                        },
                        error => {
                            alert("error")
                        }
                    );
                }                
            },
            error => {
                alert("error")
            }
        );
    }
    getSEO(page: string) {
        this._seoService.getSEO(page).subscribe((resp: any) => {
          console.log(resp)
          if (resp != null) {
            this.tituloseo = resp.titulo;
            this.descripcionseo = resp.descripcion;
            this.urlcanonicaseo = resp.urlcanonica;
            this.imagenseo = resp.imagen;
      
            this._urlcanonicaservice.createCanonicalLink();
            this.title.setTitle(this.tituloseo)
            this.meta.updateTag({
              name: 'description',
              content: this.descripcionseo
            })
      
            this.meta.updateTag({
              property: 'twitter:card',
              content: 'summary'
            })
            this.meta.updateTag({
              property: 'twitter:site',
              content: '@fundacionbest'
            })
            this.meta.updateTag({
              property: 'twitter:title',
              content: 'Fundación BEST'
            })
            this.meta.updateTag({
              property: 'twitter:description',
              content: this.descripcionseo
            })
            this.meta.updateTag({
              property: 'twitter:image',
              content: this.imagenseo
            })
      
            this.meta.updateTag({
              property: 'og:url',
              content: 'https://fundacionbest.org.mx/servicios'
            })
            this.meta.updateTag({
              property: 'og:title',
              content: this.tituloseo
            })
            this.meta.updateTag({
              property: 'og:image',
              content: this.imagenseo
            })
            this.meta.updateTag({
              property: 'og:description',
              content: this.descripcionseo
            })
          }
      
        });
      }
    
}